export enum StorageKeys {
  TOKEN = 'token',
  REFRESH_TOKEN = 'refreshToken',
}
